// Visible error toast. It used to be appended inside #modal with no z-index or
// position, so it rendered behind the MUI dialog backdrop and failed submits
// looked like "the button does nothing". Now it is fixed on top of everything.
const CONTAINER_ID = "toast-container";

function getContainer(): HTMLElement {
  let c = document.getElementById(CONTAINER_ID);
  if (!c) {
    c = document.createElement("div");
    c.id = CONTAINER_ID;
    Object.assign(c.style, {
      position: "fixed",
      top: "1rem",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: "20000",
      display: "flex",
      flexDirection: "column",
      gap: ".5rem",
      width: "min(92vw, 560px)",
      pointerEvents: "none",
    } as Partial<CSSStyleDeclaration>);
    document.body.appendChild(c);
  }
  return c;
}

export function showToast(
  message: string,
  severity: "error" | "success" = "error",
  duration = 7000
) {
  const container = getContainer();
  const div = document.createElement("div");
  Object.assign(div.style, {
    direction: "rtl",
    textAlign: "right",
    background: severity === "error" ? "#d32f2f" : "#2e7d32",
    color: "#fff",
    padding: ".75rem 1rem",
    borderRadius: "10px",
    boxShadow: "0 6px 18px rgba(0,0,0,.35)",
    fontFamily: "Yekan, sans-serif",
    fontSize: "0.95rem",
    lineHeight: "1.6",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    cursor: "pointer",
    pointerEvents: "auto",
  } as Partial<CSSStyleDeclaration>);
  div.textContent = message; // textContent: server text is never parsed as HTML
  const remove = () => div.parentNode && div.parentNode.removeChild(div);
  div.onclick = remove;
  container.appendChild(div);
  setTimeout(remove, duration);
}

export default function toastError(message: string) {
  showToast(message, "error");
}
